export const GET_ORDINANCE_REVISION =
  'ORDINANCE_REVISION/get_ordinance_revision';
export const GET_SINGLE_ORDINANCE_REVISION =
  'ORDINANCE_REVISION/get_single_ordinance_revision';
export const UPDATE_ORDINANCE_REVISION =
  'ORDINANCE_REVISION/update_ordinance_revision';
export const CREATE_ORDINANCE_REVISION =
  'ORDINANCE_REVISION/create_ordinance_revision';
export const REMOVE_ORDINANCE_REVISION =
  'ORDINANCE_REVISION/remove_ordinance_revision';

export const FORM_DATA = {
  name: '',
  description: '',
  year_from: '',
};
